import { useState } from 'react';
import { toast } from 'react-toastify';

export const useReportDownload = (reportService) => {
  const [downloadType, setDownloadType] = useState('');
  const [downloading, setDownloading] = useState(false);

  const handleDownload = (format, queryParams) => {
    if (downloading) return;

    try {
      setDownloadType(format);
      setDownloading(true);

      // Get URL with auth token and query params
      const downloadUrl = reportService.getDownloadUrlWithAuthToken(
        'analytical',
        format,
        queryParams
      );

      // Open in new tab
      window.open(downloadUrl, '_blank');
    } catch (error) {
      console.error('Error generating download URL:', error);
      toast.error('Erro ao gerar download. Por favor, tente novamente.', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setDownloading(false);
      setDownloadType('');
    }
  };

  return {
    downloadType,
    downloading,
    handleDownload
  };
};
